import { Trash2 } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { Button } from '@/shared/ui/button'
import { ConfirmDialog } from '@/shared/ui/confirm-dialog'

export interface DeleteButtonWithConfirmProps {
  onDelete: () => Promise<void>
  isPending: boolean
  confirmTitle: string
  successMessage: string
  onDeleted?: () => void
}

// * VI: Nút xoá + hộp thoại xác nhận, toast thành công/lỗi dùng chung cho các entity. | EN: Delete button + confirm dialog with shared success/error toasts for entities.
export function DeleteButtonWithConfirm({
  onDelete,
  isPending,
  confirmTitle,
  successMessage,
  onDeleted,
}: DeleteButtonWithConfirmProps) {
  const { t } = useTranslation()
  const [showConfirm, setShowConfirm] = useState(false)

  async function handleDelete() {
    try {
      await onDelete()
      showToast.success(successMessage)
      onDeleted?.()
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <>
      <Button
        variant="destructive"
        size="sm"
        disabled={isPending}
        onClick={(e) => {
          e.stopPropagation()
          setShowConfirm(true)
        }}
      >
        <Trash2 size={14} className="mr-1.5" />
        {t('common.delete')}
      </Button>
      <ConfirmDialog
        open={showConfirm}
        title={confirmTitle}
        confirmLabel={t('common.delete')}
        cancelLabel={t('common.cancel')}
        onConfirm={async () => {
          setShowConfirm(false)
          await handleDelete()
        }}
        onCancel={() => setShowConfirm(false)}
        variant="destructive"
      />
    </>
  )
}
